import React, { useEffect } from 'react';

const Contact: React.FC = () => {
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <div className="relative pt-20 py-20 mt-10 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-semibold text-white mb-6 text-glow">
            CONTACT US
          </h1>
          <div className="w-16 h-1 bg-red-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Ready to start your transformation? Get in touch with us and let's discuss your fitness goals.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto">
          {/* Calendly Widget */}
          <div className="bg-white rounded-lg p-2">
            <div 
              className="calendly-inline-widget" 
              data-url="https://calendly.com/kelvinkirk06/1-on-1-coaching-discovery-call?month=2025-10"
              style={{ minWidth: '320px', height: '700px' }}
            ></div>
          </div>
          
          {/* Contact Details */}
          <div className="mt-16 text-center">
            <h2 className="text-2xl text-white mb-8">CONTACT DETAILS</h2>
            <div className="space-y-6">
              <div>
                <a 
                  href="mailto:info@kelvinkirk.com" 
                  className="text-xl text-gray-300 hover:text-red-500 transition-colors block"
                >
                  insta: @eliteshapepersonaltraining
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 